import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconAvatar = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "center",
    inlineSize: "32px",
    blockSize: "32px",
    borderRadius: "full",
    backgroundColor: "fill-accent-purple-subtle",
    overflow: "hidden",
    flexShrink: "0",
    "data-test-id": "icon-avatar",
    children: /*#__PURE__*/_jsx(Text, {
      typography: "body-500",
      color: "text-core-default",
      as: "span",
      children: children
    })
  });
};